export default __webpack_public_path__ + "static/bg-schroders-5185802923ea65f75eb2f9f53810abe5.jpg";